import {Directive, HostListener, inject} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[uppercaseValue]',
})
export class UppercaseValueDirective {
  private ngControl = inject(NgControl);

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const uppercase = value.toUpperCase();
    this.ngControl.control?.setValue(uppercase, {emitEvent: false});
  }
}
